import { VueRouter } from "vue-router/types/router";
import Vue from "vue";

export class AppConfig {
    private static _instance: AppConfig;

    public static get Instance() {
        return this._instance || (this._instance = new this());
    }

    // Global config value
    private _tenant: string = "";
    public setTenant(tenant: string): void {
        this._tenant = tenant;
    }
    public getTenant(): string {
        return this._tenant;
    }

    private _vueRouter: VueRouter;
    public setVueRouter(router: VueRouter) {
        this._vueRouter = router;
    }

    public getVueRouter() {
        return this._vueRouter;
    }

    public isProduction(): boolean {
        return process.env["NODE_ENV"] === "production";
    }
}
